import {createFileRoute, Outlet, useLocation} from '@tanstack/react-router';
import {PRACTICIONER_LIST} from '@/practitioner/routing/paths';
import {viewPractitionersGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import PractitionerList from '@/practitioner/views/practitioner/PractitionerList';

const PractitionersLayout = () => {
  const {pathname} = useLocation();
  const isRoot = pathname === PRACTICIONER_LIST;
  return isRoot ? <PractitionerList /> : <Outlet />;
};

export const Route = createFileRoute('/(practitioner)/company/practitioners')({
  component: PractitionersLayout,
  beforeLoad: grantUser(viewPractitionersGranted)
});
